import styled from 'styled-components';

export const Box = styled.div`
  padding: 16px;
  gap: 12px;
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-radius: 8px;
  &:not(&:first-of-type) {
    margin-top: 24px;
  }
`;

export const QuestionNumberLabel = styled.p`
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 12px;
  color: ${(props) => props.theme.colors['neutral-80']};
`;

export const QuestionInput = styled.div`
  width: 100%;
  margin-top: -5px;
  margin-bottom: 5px;
`;

export const QuestionLabel = styled.p`
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
